// @ts-nocheck
/**
 * Formats a notification timestamp as a localized relative string (e.g. "2 hours ago", "yesterday").
 *
 * Uses Intl.RelativeTimeFormat so the wording is locale-aware without introducing new translation
 * keys. Displays a full spelled-out localized wording — e.g. "2 hours
 * ago" / "yesterday" — rather than the abbreviated "2 h ago" / "2d ago" seen in some Figma frames,
 * and that timestamps keep counting relatively indefinitely (no roll-over to an absolute date for now).
 */
type Division = {
    /** Upper bound (exclusive) of this unit before rolling up to the next. */
    amount: number;
    unit: Intl.RelativeTimeFormatUnit;
};

const divisions: Division[] = [
    { amount: 60, unit: "seconds" },
    { amount: 60, unit: "minutes" },
    { amount: 24, unit: "hours" },
    { amount: 7, unit: "days" },
    { amount: 4.34524, unit: "weeks" },
    { amount: 12, unit: "months" },
    { amount: Number.POSITIVE_INFINITY, unit: "years" },
];

const getRelativeNotificationTime = (dateTime?: Date | string | null, language?: string): string => {
    if (!dateTime) {
        return "";
    }

    const date = typeof dateTime === "string" ? new Date(dateTime) : dateTime;
    if (Number.isNaN(date.getTime())) {
        return "";
    }

    const formatter = new Intl.RelativeTimeFormat(language || undefined, { numeric: "auto" });

    // Negative for the past, which is the expected case for notifications.
    let duration = (date.getTime() - Date.now()) / 1000;

    for (const division of divisions) {
        if (Math.abs(duration) < division.amount) {
            return formatter.format(Math.round(duration), division.unit);
        }
        duration /= division.amount;
    }

    return "";
};

export default getRelativeNotificationTime;
